import React from 'react'
import { QuestionTypeComponentType } from '@core/components/templateAnswersForm'
import { Box } from '@fundamentals'
import { localizedStrings } from '@core/strings'
import { Button } from '@common/material'
import { Add } from '@mui/icons-material'
import {
  InspectionResponseForm,
  ResponseValue,
} from '@elements/Questions/questionTypes/Inspection'
import { Collapse } from '@mui/material'
import { TransitionGroup } from 'react-transition-group'
import { v4 as uuidv4 } from 'uuid'
import { InspectionAnswer } from '@elements/Questions/questionTypes/Inspection/InspectionAnswer'
import { IInspectionItemAnswer } from '@core/entities/InspectionItemAnswer'
import { useModal } from '@common/GlobalModal'
import { useFormContext } from 'react-hook-form'

const InspectionQuestion: QuestionTypeComponentType = ({
  question,
  inputProps: { value = question, onChange } = {},
  readOnly,
  projectId,
  attachmentTypes,
}) => {
  const { showModal, hideModal } = useModal()
  const formContext = useFormContext()
  const inspectionTaskTemplates =
    formContext?.getValues('template')?.currentVersion?.templateQuestions?.[0]
      ?.inspectionTaskTemplates || []
  const projectLocations = formContext?.watch('projectLocations')

  const onSaveResponse = ({ answer }: { answer: IInspectionItemAnswer }) => {
    const isEditing = !!answer.id
    const inspectionItemAnswers = isEditing
      ? value?.inspectionItemAnswers.map((item) =>
          item.id === answer.id ? answer : item,
        )
      : [...(value?.inspectionItemAnswers || []), { ...answer, id: uuidv4() }]

    onChange({
      ...value,
      inspectionItemAnswers,
    })
    hideModal()
  }

  const handleDelete = (id: string) => {
    const inspectionItemAnswers = value?.inspectionItemAnswers.filter(
      (answer) => answer.id !== id,
    )
    onChange({
      ...value,
      inspectionItemAnswers,
    })
  }

  const handleOpenResponseModal = (
    initialValues?: IInspectionItemAnswer,
    openTaskModal?: boolean,
  ) => {
    showModal(
      <InspectionResponseForm
        openTaskModal={openTaskModal}
        inspectionTaskTemplates={inspectionTaskTemplates}
        projectLocations={projectLocations}
        attachmentTypes={attachmentTypes}
        question={question}
        onSave={onSaveResponse}
        onDelete={handleDelete}
        projectId={projectId}
        initialValues={{
          ...initialValues,
          first:
            initialValues?.first || !question?.inspectionItemAnswers?.length,
        }}
      />,
    )
  }

  return (
    <Box data-test={`${question.id}-INSPECTION_ITEM`}>
      <TransitionGroup>
        {question?.inspectionItemAnswers?.map((inspectionItemAnswer, index) => {
          return (
            <Collapse key={index}>
              <InspectionAnswer
                inspectionItemAnswer={inspectionItemAnswer}
                readOnly={readOnly}
                onChangeResponse={handleOpenResponseModal}
                data-test={`inspection-answer-${inspectionItemAnswer.inspectionItemAnswerType}`}
              />
            </Collapse>
          )
        })}
      </TransitionGroup>
      {!readOnly &&
        question?.inspectionItemAnswers?.[0]?.inspectionItemAnswerType !==
          ResponseValue.NA && (
          <Button
            startIcon={<Add />}
            onClick={() => handleOpenResponseModal()}
            data-test='add-response-btn'
          >
            {localizedStrings.addResponse}
          </Button>
        )}
    </Box>
  )
}

export { InspectionQuestion }
